// Helpers for city-based SEO pages.
// City data is fetched live from /api/cities (aggregated from active job postings).
// We only define slug/lookup helpers here.

export const slugifyCity = (name, state) => {
  const base = (name || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  const st = (state || "").toLowerCase().replace(/[^a-z]/g, "");
  return st ? `${base}-${st}` : base;
};

export const cityFullName = (city) => {
  if (!city) return "";
  return city.state ? `${city.name}, ${city.state}` : city.name;
};

// Derive a display city object from a URL slug (e.g. "allentown-pa" → Allentown, PA).
// Used as a graceful fallback so city landing pages always render, even if the
// backend can't resolve the slug — we never show a "city not found" dead-end.
export const cityFromSlug = (slug) => {
  if (!slug) return { slug: "", name: "", state: "" };
  const parts = String(slug).toLowerCase().split("-");
  let state = "";
  let nameParts = parts;
  const last = parts[parts.length - 1];
  if (parts.length >= 2 && /^[a-z]{2}$/.test(last)) {
    state = last.toUpperCase();
    nameParts = parts.slice(0, -1);
  }
  const name = nameParts
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
  return { slug, name, state };
};
